import React from 'react';
import PropTypes from 'prop-types';
import s from '../lib/composeLabels.js';

const {
  shape,
  number,
  string,
  object
} = PropTypes;
function ProgressBar({
  value,
  style,
  labels
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "slds-progress-bar tds-progress-bar",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": value,
    role: "progressbar",
    style: style,
    "data-test": "progress-bar"
  }, /*#__PURE__*/React.createElement("span", {
    className: "slds-progress-bar__value",
    style: {
      width: `${value}%`
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "slds-assistive-text"
  }, s(labels.progress, {
    n: value
  }))));
}
ProgressBar.displayName = "ProgressBar";
ProgressBar.defaultProps = {
  style: null
};
ProgressBar.propTypes = {
  /**
   * Progress value. Min: 0, Max: 100.
   */
  value: number.isRequired,
  /**
   * i18n and a11y labels.
   */
  labels: shape({
    progress: string.isRequired
  }).isRequired,
  /**
   * Style overrides. I.e: `{ color: "red" }`
   */
  style: object // eslint-disable-line react/forbid-prop-types
};

export { ProgressBar as default };
